/**
 * E1 -- one denial, with a way out.
 *
 * Eight admin surfaces each carried their own variant of "X is
 * admin-only. Ask an admin to grant the role." Two problems: the
 * wording drifted, and none of them offered anywhere to go. A person
 * who followed a link into a room they cannot enter was left standing
 * in it, with (until E1) a nine-tab admin strip above them promising
 * eight more rooms that would refuse them too.
 *
 * Says the same thing everywhere, names what would change it, and
 * gives the way back to work they CAN do.
 */
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function AdminOnlyPanel({ surface }: { surface: string }) {
  const { t } = useTranslation();
  return (
    <div
      data-testid="admin-only-panel"
      data-surface={surface}
      className="max-w-2xl rounded border border-amber-300 bg-amber-50 p-4 text-sm text-amber-900"
    >
      <p>{t("adminOnly.body", { surface })}</p>
      <p className="mt-2">
        <Link
          data-testid="admin-only-back"
          to="/my-work"
          className="font-medium text-brand-brassDark hover:underline"
        >
          {t("adminOnly.back")}
        </Link>
      </p>
    </div>
  );
}
